import React from 'react';
import { Link } from 'react-router-dom';
import legalIcon from '../images/legal.svg';
import stockIcon from '../images/stock.svg';
import quoteIcon from '../images/quote.svg';
import datingIcon from '../images/dating.svg';

const Portfolio = () => {
    const products = [
        { 
            name: 'LegalLens', 
            description: "An AI-powered legal assistant that provides instant case insights, precedent analysis, and document review. Helps lawyers make data-driven decisions and streamline case management.", 
            link: '/contact#contact',
            icon: legalIcon
        },
        { 
            name: 'StockSense', 
            description: "A powerful desktop application for real-time NIFTY stock analysis and insights. Features advanced charting, technical indicators, and automated trading signals to help investors make informed decisions.", 
            link: '/contact#contact',
            icon: stockIcon
        },
        { 
            name: 'Motivatory', 
            description: "A sleek mobile app that delivers daily motivational quotes with beautiful designs. Features one-tap sharing to WhatsApp status and other social media platforms, making it easy to spread positivity.", 
            link: '/contact#contact',
            icon: quoteIcon
        },
        { 
            name: 'ValentineMatch', 
            description: "A fun and engaging dating app that helps people find meaningful connections. Features personality matching, ice-breaker games, and safe chat options to create romantic possibilities.", 
            link: '/contact#contact',
            icon: datingIcon
        }
    ]
    return (
        <>
            <div className="pb-8 bg-gradient-to-r from-primary to-[#FF8C42]" id='portfolio'>
                <h2 className="text-center text-3xl text-secondary uppercase font-bold">Portfolio</h2>
                <div className='flex justify-center'>
                        <div className='w-24 border-b-4 border-secondary my-4'></div>
                    </div>

                <div className="px-4 mt-6" data-aos="fade-down" data-aos-delay="600">
                    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                        {products.map((product, index) => (
                            <div key={index} className="bg-secondary transition-all ease-in-out duration-400 overflow-hidden text-greyText hover:bg-gray-700 hover:text-white rounded-lg shadow-2xl p-3 group">
                                <div className="m-2 text-justify text-sm">
                                    <div className="flex justify-center mb-4">
                                        <img 
                                            src={product.icon} 
                                            alt={`${product.name} icon`} 
                                            className="w-24 h-24 object-contain group-hover:scale-110 transition-transform duration-300"
                                        />
                                    </div>
                                    <h2 className="font-semibold my-4 font-sectionHeader text-sectionHeader xs:text-[0.875rem] xsm:text-[1rem] sm:text-[1.125rem] md:text-[1.25rem] lg:text-[1.25rem] xl:text-[1.25rem] text-center ">{product.name}</h2>
                                    <p className="font-body text-body xs:text-[0.75rem] xsm:text-[0.875rem] sm:text-[1rem] md:text-[1rem] lg:text-[1rem] xl:text-[1rem] hover:text-white">{product.description}</p>
                                    <div className="flex justify-center my-4">
                                        <Link 
                                            to="/contact#contact" 
                                            state={{ isDemoRequest: true, productName: product.name }}
                                            className="text-secondary bg-primary hover:bg-secondary hover:text-primary font-body text-body font-body text-body xs:text-[0.75rem] xsm:text-[0.875rem] sm:text-[1rem] md:text-[1rem] lg:text-[1rem] xl:text-[1rem] inline-flex items-center justify-center w-full px-6 py-3 my-4 text-lg shadow-xl rounded-xl"
                                        >
                                            Schedule Demo
                                            <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Portfolio;